import { useState, useEffect } from 'react'
import axios from 'axios'
import { useAuth } from '../context/AuthContext'
import { supabase } from '../lib/supabase'

async function getHeaders() {
  const { data: { session } } = await supabase.auth.getSession()
  return session ? { Authorization: `Bearer ${session.access_token}` } : {}
}

// Returns the set of user IDs the current user has blocked
export function useBlocks() {
  const { user } = useAuth()
  const [blockedIds, setBlockedIds] = useState(new Set())

  useEffect(() => {
    if (!user) { setBlockedIds(new Set()); return }
    getHeaders().then(headers =>
      axios.get('/api/blocks', { headers })
        .then(r => setBlockedIds(new Set(r.data)))
        .catch(err => console.error('[useBlocks] Failed to fetch blocked user ids:', err))
    )
  }, [user?.id])

  return blockedIds
}
